// extracted by mini-css-extract-plugin
export default {"order__header":"Order_order__header__2RZxm"};